import React, {useState, useEffect} from 'react';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CircularProgress from '@mui/material/CircularProgress'
import Controls from '../../components/controls/Controls'
import { Button, Container, TextField, Typography, Grid, FormControl, Box, Menu, MenuItem, Fade } from '@mui/material'
import { ReactComponent as SettingIcon } from "../../assets/icons/icon-feather-settings.svg"
import { ReactComponent as AddSquareIcon } from "../../assets/icons/icon-add-square.svg"
import { ReactComponent as MoreIcon } from "../../assets/icons/icon-more.svg";
import { ReactComponent as RightAngleIconIcon } from "../../assets/icons/icon-angle-right-small-secondary.svg";
import AddIcon from '@mui/icons-material/Add'
import { Link as RouterLink,useLocation } from 'react-router-dom'
import { DecryptData } from "../../utils/encryptDecrypt";
import ExportReactCSV from "../../utils/ExportCSV";
import { initXLSXExport } from "../../utils/ExportXLSX";
import Loader from '../../pages/Loader';


const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  title: {
    color: '#202124',
    fontSize: '22px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#202124',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  headingButton: {
    display: 'block',
    width: '100%',
  },
  headingIcon: {
    display: 'flex',
    '&:hover': {
      background: 'none',
    },
  },
  reportHeader: {
    background: 'transparent',
    boxShadow: 'none',
    // borderBottom: '1px solid #DEDEDE',
  },
  button: {
    color: '#202124',
    fontWeight: 'normal',
    '&:hover': {
      background: 'none',
    },
    marginLeft: 0,
    paddingLeft: 0,
  },
  headingButtonWrap: {
    width: '90%',
    float: 'right',
    padding: '0 1rem',
    '&:hover': {
      backgroundColor: '#f45e29',
    },
    ['@media (max-width:1700px)']: {
      padding: '0 0.5rem',
      width: '95%',
      lineHeight: '16px',
      textAlign: 'center',
    },
    ['@media (max-width:1400px)']: {
      padding: '0.2rem 0.5rem',
      width: '100%',
      textAlign: 'center',
      lineHeight: '16px',
    },
    ['@media (max-width: 1199px)']: {
      float: 'left',
    }
  },
  headerButtons: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    },
  },
  menuDropdownItem: {
    fontSize: '14px',
    color: '#202124',
    '&:hover': {
      backgroundColor: '#f6f6f6'
    }
  }
}));

export default function ReportHeader({ onSaveLoader, onhandleSaveReport, onChangeReportName, reportNameValue, onSettingsToggle, onOpenCalculatedFields,
  handleReportDescription, description, onOpenSidebar, handleSaveAsPoup, handleDeleteReportPopup, exportPDFWithMethod,currentUserType,mapResponseForQuery, reportDetails,setExportProcessDialog, columnTitle, columnDisplayName}) {

  const queryParams = useLocation().search;
  const IsExportUrl = new URLSearchParams(queryParams).get('export');
  const exportType = new URLSearchParams(queryParams).get('type')
 
  const classes = useStyles();
  const currentRole = DecryptData(localStorage.getItem('role'))
  const [addMenuEl, setAddMenuEl] = React.useState(null);
  const openAddMenu = Boolean(addMenuEl);
  const [exportCsv,setExportCsv] = useState(false)
  const handleAddMenuHover = (event) => {
    if (addMenuEl !== event.currentTarget) {
      setAddMenuEl(event.currentTarget);
    }
  };
  const handleAddMenuClose = () => {
    setAddMenuEl(null);
  };

  const [moreMenuEl, setMoreMenuEl] = React.useState(null);
  const [moreExportMenuEl, setMoreExportMenuEl] = React.useState(null);
  const openMoreMenu = Boolean(moreMenuEl);
  const openMoreExportMenu = Boolean(moreExportMenuEl);
  const handleMoreMenuHover = (event) => {
    if (moreMenuEl !== event.currentTarget) {
      setMoreMenuEl(event.currentTarget);
    }
  };

  const handleMoreExportMenuClick = (event) => {
    if (moreExportMenuEl !== event.currentTarget) {
      setMoreExportMenuEl(event.currentTarget);
    }
  };
  const handleMoreMenuClose = () => {
    setMoreMenuEl(null);
  };

  const handleExport = (exportType) => {
    setMoreExportMenuEl(null);
    setMoreMenuEl(null);

    

    switch(exportType) {
      case 'pdf':
        exportPDFWithMethod("report");
        break;
      case 'csv':
        setExportCsv(true)
        break;
      case 'excel':
        initXLSXExport(reportDetails, mapResponseForQuery, columnTitle, columnDisplayName)
        break;
      default:
        return
    }
  }
  useEffect(() => {
   if(IsExportUrl === true || IsExportUrl === "true" && exportType && reportDetails?.reportDetails) {
      setExportProcessDialog(true)
      switch(exportType) {
        case 'pdf':
        exportPDFWithMethod();
        break;
        case 'csv':
          setExportCsv(true)
          break
        case 'excel':
          initXLSXExport(reportDetails, mapResponseForQuery, columnTitle, columnDisplayName)
          break
        default:
          return      
    }
    if(reportDetails?.reportDetails) {  
        setTimeout(() =>{
          window.close()
          setExportProcessDialog(false)
        },[5000])  
    }
   }
  },[IsExportUrl,reportDetails])


  return (
    <div className={classes.grow}>
      {
        exportCsv && 
        <div style={{ position: "relative" }}>
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 99999, opacity: 0 }} />
          <Loader />
        </div>
      }      
      <AppBar className={classes.reportHeader} position="relative">
        <Toolbar className="p-0">

          <Grid container mb={2} className="report-new-header-container" justifyContent="space-between"  >
            <Grid container item alignItems="start" justifyContent="center" direction="column" mb={2}
              sm={12} md={12} lg={5} order={{ lg: 1, md: 2, sm: 2, xs: 2 }} >
              <FormControl sx={{ marginBottom: '1rem' }}>
                <TextField placeholder="Report Name" size="small" variant="standard" value={reportNameValue} onChange={onChangeReportName}
                  className="report-header-input main-title" />
              </FormControl>
              <FormControl fullWidth className={classes.margin}>
                <TextField placeholder="Add Description" size="small" variant="standard" value={description} onChange={handleReportDescription}
                  className="report-header-input" />
              </FormControl>
            </Grid>

            <Grid className="report-header-action-items" container item mb={2} spacing={0} alignItems="center"
              sm={12} md={12} lg={5} order={{ lg: 2, md: 1, sm: 1, xs: 1 }} >
              <Grid item xs={12} sm={6} md={6} lg={6}  alignItems=""  >
                <Box >
                  <Grid display="flex" justifyContent="flex-end" className="report-header-menu">
                    <Grid className="" item lg={4}  >
                      <div className={classes.headingIcon}>
                        <Controls.Button className={classes.button + " menu-btn"} text="Add" startIcon={<AddSquareIcon />} variant="text"
                          id="add-button"
                          aria-controls="add-menu"
                          aria-haspopup="true"
                          aria-expanded={openAddMenu ? 'true' : undefined}
                          onClick={handleAddMenuHover}
                        />
                        <Menu
                          id="add-menu"
                          MenuListProps={{
                            'aria-labelledby': 'add-button',
                            'onMouseLeave': handleAddMenuClose
                          }}
                          classes={{
                            root: 'popover-menu'
                          }}
                          PaperProps={{
                            style: {
                              minWidth: 150,
                            },
                          }}
                          anchorEl={addMenuEl}
                          open={openAddMenu}
                          onClose={handleAddMenuClose}
                          TransitionComponent={Fade}
                        >
                          {
                          (currentRole?.toLowerCase() === 'superadmin' ||  
                          currentUserType && currentUserType?.customFieldCreation !== false) &&
                            <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenCalculatedFields(true)}>Add calculated fields</MenuItem>
                          }
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenSidebar({ title: 'Settings' })} >Add Title</MenuItem>
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenSidebar({ title: 'Filter' })} >Add Filter</MenuItem>
                        </Menu>
                      </div>
                    </Grid>


                    <Grid className="" item lg={4} >
                      <div className={classes.headingIcon}>
                        <Controls.Button className={classes.button + " menu-btn"} text="More" startIcon={<MoreIcon />} variant="text"
                          id="more-button"
                          aria-controls="more-menu"
                          aria-haspopup="true"
                          aria-expanded={openMoreMenu ? 'true' : undefined}
                          onClick={handleMoreMenuHover}
                        />
                        <Menu
                          id="more-menu"
                          MenuListProps={{
                            'aria-labelledby': 'more-button',
                            //'onMouseLeave': handleMoreMenuClose
                          }}
                          classes={{
                            root: 'popover-menu-report-header popover-menu'
                          }}
                          PaperProps={{
                            style: {
                              minWidth: 110,
                            },
                          }}
                          anchorEl={moreMenuEl}
                          open={openMoreMenu}
                          onClose={handleMoreMenuClose}
                          TransitionComponent={Fade}
                        >
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleSaveAsPoup('open')}>Copy</MenuItem>
                          {
                           ((reportDetails?.reportDetails?.measures?.length || reportDetails?.reportDetails?.dimensions?.length ) &&currentRole?.toLowerCase() === 'superadmin' || (currentUserType && currentUserType?.exportAuth && (currentUserType?.exportAuth?.pdf || currentUserType?.exportAuth?.csv || currentUserType?.exportAuth?.excel  )
                           )) &&
                          <MenuItem className={classes.menuDropdownItem + " menu-item popover-menu-item"} onClick={(e) => handleMoreExportMenuClick(e)} >Export
                            <RightAngleIconIcon className="re-menuitem-more-icon" />
                          </MenuItem>
                          }
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleDeleteReportPopup('open')} >Delete</MenuItem>
                        </Menu>

                        <Menu
                          id="more-export-menu"
                          MenuListProps={{
                            'aria-labelledby': 'more-export-button',
                            //'onMouseLeave': () => setMoreExportMenuEl(null)
                          }}
                          classes={{
                            root: 'popover-exportmenu-report-header popover-menu'
                          }}
                          PaperProps={{
                            style: {
                              minWidth: 110,
                            },
                          }}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                          anchorEl={moreExportMenuEl}
                          open={openMoreExportMenu}
                          onClose={() => setMoreExportMenuEl(null)}
                          TransitionComponent={Fade}
                        >
                          { (currentRole?.toLowerCase() === 'superadmin' || (  
                          currentUserType && currentUserType?.exportAuth?.pdf) )&&
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('pdf')}>PDF</MenuItem>
                        }
                        {(currentRole?.toLowerCase() === 'superadmin' || (  
                          currentUserType && currentUserType?.exportAuth?.csv) )&&
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('csv')} >CSV file</MenuItem>
                        }
                        { (currentRole?.toLowerCase() === 'superadmin' || (  
                          currentUserType && currentUserType?.exportAuth?.excel)) &&
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleExport('excel')} >Excel file</MenuItem>
                        }
                        </Menu>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} justifyContent="flex-end" >
                <Grid container spacing={2} display="flex" className={classes.headerButtons}>
                  <Grid className="" item xs={6} sm={6} lg={6}>
                    <Box className={classes.headingButton}>
                      <Controls.Button className={classes.headingButtonWrap + ' ' + "report_form_ui_btn icon-btn"} variant="contained"
                        onClick={onhandleSaveReport}
                        disabled={onSaveLoader}
                        text={onSaveLoader ? (<CircularProgress color="white" size={22} />) : "Save"}
                      />
                    </Box>
                  </Grid>
                  <Grid className="" item xs={6} sm={6} lg={6} >
                    <Box className={classes.headingButton} >
                      <Controls.Button className={classes.headingButtonWrap + ' ' + "report_form_ui_btn icon-btn"} text="New Report" variant="contained"
                        startIcon={<AddIcon className="btn_icon_before" />} href="/reportGraph/new" target="_blank" />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {
        exportCsv && reportDetails?.reportDetails &&
        <ExportReactCSV mapResponseForQuery={mapResponseForQuery} reportDetails={reportDetails} setExportCsv={setExportCsv} setExportProcessDialog={setExportProcessDialog} columnTitle={columnTitle} columnDisplayName={columnDisplayName}/>
      }
    </div>
  );
}
